import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/auth/auth.guard';
import { DealerPublicComponent } from '../dealer/dealer-public/dealer-public.component';
import { DealerAccountComponent } from '../dealer/dealer-account/dealer-account.component';
import { DealerAccountMainComponent } from './dealer-account.component';
import { SupportComponent } from 'src/app/public/support/support.component';
import { NotFoundComponent } from 'src/app/auth/not-found/not-found.component';

const routes: Routes = [
  { path: '', component: DealerAccountMainComponent,
    children: [
      { path: '', canActivate: [AuthGuard], component: DealerAccountComponent },
      { path: 'infos', canActivate: [AuthGuard], component: DealerAccountComponent },
      { path: 'parameters', canActivate: [AuthGuard], component: DealerAccountComponent },
      { path: 'public', component: DealerPublicComponent },

      //{ path: 'contracts', component: SupportComponent },
      { path: 'support/cases', component: SupportComponent },
      { path: 'support/faq', component: SupportComponent },
      { path: '**', component: NotFoundComponent },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DealerAccountRoutingModule { }
